export const SETTINGS_PAGES = {
  companyProfile: 'companyProfile',
  addSubsidiaryCompany: 'addSubsidiaryCompany',
  editCompanyProfile: 'editCompanyProfile',
  absence: 'absence',
  documentsLabels: 'documentsLabels',
  documents: 'documents',
  emailTemplates: 'emailTemplates',
  permissionGroup: 'permissionGroup',
  permissionGroupsEdit: 'permissionGroupsEdit',
  datev: 'datev',
  payrollAccounting: 'payrollAccounting',
  editDatev: 'editDatev',
  editConsultantNumber: 'editConsultantNumber',
  employeeDevelopment: 'employeeDevelopment',
  holidayManager: 'holidayManager',
  employeeQuestionnaire: 'employeeQuestionnaire',
  questionnairePreview: 'questionnairePreview',
  healthInsurance: 'healthInsurance',
  salaryTypes: 'salaryTypes',
  applications: 'applications',
  processTemplates: 'processTemplates',
  documentImport: 'DocumentImport',
};
